// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".remove-trigger-attachment_be1fe602{color:#b32700}.remove-trigger-attachment_be1fe602:hover{color:#b32700}", ""]);
// Exports
export var removeTriggerAttachment = "remove-trigger-attachment_be1fe602";
export default ___CSS_LOADER_EXPORT___;
